<template>
  <div class="fan fan-component f-plugin-record">
    <f-layout ref="flayout"
              v-if="superApi && superColumns"
              :superPage="page"
              :superApi="superApi"
              @reloadData="loadData">
      <!-- 面包屑 -->
      <!-- <template #breadcrumb><div></div></template> -->
      <!-- 头部 -->
      <template #head v-if="superTitle || $slots.subHead">
        <div class="head" style="padding:20px;font-size: 1.1em; font-weight: bold;" v-if="superTitle">{{superTitle}}</div>
        <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
      </template>
      <!-- 检索 -->
      <template #subHeadLeft v-if="$slots.subHeadLeft">
        <slot name="subHeadLeft"></slot>
      </template>
      <template #subHeadLeft v-else>
        <f-search :superFilter="page.filter"
                  :superColumns="superColumns"
                  @change="bindSearchChange"
                  @reloadData="reloadData()">
        </f-search>
      </template>
      <!-- 按钮组 -->
      <template #subHeadRight v-if="$slots.subHeadRight">
        <slot name="subHeadRight"></slot>
      </template>
      <!-- <template #subHeadRight v-else>
        <a-button-group>
          <a-button @click="loadData()" ><template #icon><icon-refresh /></template>刷新</a-button>
        </a-button-group>
      </template> -->
      <!-- 子菜单 -->
      <template #menus v-if="menus && router.navInfo && !router.navInfo.hasTmp">
        <a-menu mode="inline"
                :style="{ height: '100%', borderRight: 0 }"
                :defaultOpenKeys="[`/${router.info.path[0]}/${router.info.path[1]}`]"
                :defaultSelectedKeys="[`${router.info.url}`]">
          <template v-for="(item, index) in menus">
            <a-sub-menu :key="index"
                        v-if="item.info.show &&
                              item.info.type==='nav' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{item.info.name}}</span>
              </template>
              <template v-for="(item2, index2) in menus">
                <a-menu-item :key="index2"
                             v-if="item2.info.type==='nav' &&
                                   item2.info.level===(router.navInfo.level+2)"
                             @click="$fan.page.open(index2)">
                    <span>
                      <component :is="'icon-' + item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item :key="'menu-' + index"
                         v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                         @click="$fan.page.open(index)">
                  <span>
                    <component :is="'icon-' + item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
            </a-menu-item>
          </template>
        </a-menu>
      </template>
      <!-- 列表 -->
      <template #body>
        <f-table v-if="data.data"
                 ref="ftable"
                 :superData="data"
                 :superColumns="superColumns"
                 :superFilter="page.filter"
                 :superLoading="page.loading || page.initing"
                 @reloadData="reloadData()"
                 @change="bindTableChange"
                 @view="(record) => $refs.flayout.bindOpenCurd('详情', { record })"
                 @edit="(record) => $refs.flayout.bindOpenCurd('编辑', { record })">
          <!-- 传递自定义操作列模板 -->
          <template #action="{ record }">
            <slot name="action" :record="record" />
            <template v-if="!$slots.action">
              <div class="action-btn-group">
                <a-tooltip content="查看">
                <div class="action-btn" @click="$refs.flayout.bindOpenCurd('详情', { record })">
                  <icon-eye />
                </div>
                </a-tooltip>
                <a-tooltip content="编辑">
                <div class="action-btn" @click="$refs.flayout.bindOpenCurd('编辑', { record })">
                  <icon-edit />
                </div>
                </a-tooltip>
                <!-- <a-popconfirm content="确定要删除这条记录吗？" @ok="bindDeleteRecord({record})">
                  <div class="action-btn delete-btn">
                    <icon-delete />
                  </div>
                </a-popconfirm> -->
              </div>
            </template>
          </template>
        </f-table>
      </template>
    </f-layout>
  </div>
</template>

<script>
  import moment from 'moment'
  import 'moment/locale/zh-cn'
  export default {
    name: 'FPluginRecord',
    props: {
      superTitle: String,
      superApi: String,
      superColumns: Array
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },
    mounted() {
      if (this.superApi && this.superColumns) {
        this.reloadData()
      }
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        return this.routers[this.$route.path] || {}
      },
      query() {
        const query = this.$route.query
        if (this.$fan.utils.notEmpty(query)) {
          return query
        } else {
          return false
        }
      },
            menus() {
        if (!this.router || !this.router.info || !this.router.info.path) return false
        
        const path = this.router.info.path
        return (path.length === 5 || path.length === 6) && this.menuList.length > 0
      },
      menuReady() {
        return this.menuList.length > 0 && this.openNames.length >= 0
      },
      menuList() {
        const currentPath = this.$route.path.split('?')[0]
        const all = Object.values(this.$store.state.routers)
        
        let currentRouter = all.find(item => item.info && item.info.url === currentPath)
        
        if (!currentRouter) {
          const sortedRoutes = [...all].sort((a, b) => {
            const lenA = a.info && a.info.url ? a.info.url.length : 0
            const lenB = b.info && b.info.url ? b.info.url.length : 0
            return lenB - lenA
          })
          
          currentRouter = sortedRoutes.find(item => item.info && item.info.url && currentPath.startsWith(item.info.url))
        }
        
        if (!currentRouter || !currentRouter.info || !currentRouter.info.path) return []

        const path = currentRouter.info.path

        const parentPath = path.slice(0, -1)
        const parentUrl = '/' + parentPath.join('/')

        const siblings = all.filter(item => {
          if (!item.info || !item.info.path || !item.info.show) return false
          if (item.info.path.length !== path.length) return false

          const itemParent = item.info.path.slice(0, -1)
          return '/' + itemParent.join('/') === parentUrl
        })

        return this.buildMenuTree(siblings, all)
      },

      openNames() {
        const storageKey = `fan-menu-open-names-${this.$route.path}`
        const savedOpenNames = localStorage.getItem(storageKey)
        if (savedOpenNames) {
          try {
            return JSON.parse(savedOpenNames)
          } catch (e) {}
        }

        // 默认收起，用户手动点击才展开
        return []
      },
      activeMenu() {
        const storageKey = `fan-menu-active-${this.$route.path}`
        const savedActive = localStorage.getItem(storageKey)
        if (savedActive) {
          return savedActive
        }
        const active = this.$route.path.split('?')[0]
        return active
      }, 
      menuStyle() {
          return {
            height: '100%',
            borderRight: 0,
            backgroundColor: 'var(--menu-bg, #fff)',
            color: 'var(--menu-text, #000)'
          }
      },
    },
    data() {
      return {
        data: { data: [], count: 0 }, page: {},
        def: {
          data: { data: null, count: 0 },
          page: {
            initing: false,
            loading: false,
            filter: {
              page: 1,
              limit: 10
            }
          }
        }
      }
    },
    methods: {
      async loadData() {
        this.page.loading = true
        // 过滤掉不在 columns 中的多余查询字段
        const validKeys = new Set(this.superColumns.map(c => c.dataIndex))
        const cleanFilter = { ...this.page.filter, page: this.page.filter.page || 1, limit: this.page.filter.limit || 10 }
        for (const k in cleanFilter) {
          if (!['page', 'limit'].includes(k) && !validKeys.has(k)) {
            delete cleanFilter[k]
          }
        }
        const res = await this.$fan.api.get(this.superApi, cleanFilter)
        this.data = res
        this.$store.state.page.data = res
        // 确保 store 有 columns 数据供 FDetail/FForm 使用
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.loading = false
      },
      async reloadData() {
        this.page.initing = true
        this.page.filter = this.$fan.utils.parse(this.def.page.filter)
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.initing = false
      },
      async bindSearchChange(filter={}) {
        this.page.loading = true
        this.page.filter = {...filter, ...this.def.page.filter}
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.loading = false
      },
      bindTableChange(pagination, filters, sorter) {
        this.page.filter.page = pagination.current
        this.page.filter.limit = pagination.pageSize
        this.loadData()
      },
      async bindDeleteRecord({record}) {
        let api = this.superApi.split('?')[0]
        await this.$fan.api.delete(`${api}/${record.id}`)
        this.loadData()
      },
      bindOpenCurd(title, record) {
        this.$refs.zlayout.bindOpenCurd(title, record)
      },
      async exportexcel() {
        let xlsColumns = []
        const columns = this.superColumns
        const data = JSON.parse(JSON.stringify(this.data.data))
        for (let k in columns) {
          if ([
            'Id', 'ID', '操作'
          ].indexOf(columns[k].title) < 0) {
            xlsColumns.push({
              label: columns[k].title,
              prop: columns[k].dataIndex
            })
            if (columns[k].form == 'select') {
              for (let kk in data) {
                data[kk][columns[k].dataIndex] = this.$fan.page.getOptionName(columns[k].dataIndex, data[kk][columns[k].dataIndex])
              }
            } else if (columns[k].form == 'cascader') {
              for (let kk in data) {
                data[kk][columns[k].dataIndex] = this.$fan.page.getOptionName(columns[k].dataIndex, data[kk][columns[k].dataIndex])
              }
            }
          }
        }
        this.$export.excel({
          columns: xlsColumns,
          data: data,
        })
      },
    }
  }
</script>

<style scoped lang="less">
.action-btn-group {
      display: inline-flex;
      align-items: center;
      border: 1px solid #e5e6eb;
      border-radius: 5px;
      overflow: hidden;
      .action-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        color: #4e5969;
        cursor: pointer;
        transition: all 0.2s;
        // 给按钮之间加分割线，模拟按钮组效果
        &:not(:last-child) {
          border-right: 1px solid #e5e6eb;
        }
        &:hover {
          color: #1677ff;
          background-color: #f2f3f5;
        }
      }
      .delete-btn {
        background-color: #f53f3f;
        color: #fff;
        &:hover {
          color: #fff;
          background-color: #f9695e;
        }
      }
      .other-btn {
        background-color: #186df6 !important;
        color: #fff !important;
        &:hover {
          color: #fff !important;
          background-color: #5185f5 !important;
        }
        .arco-icon {
          color: inherit !important;
        }
      }
    }
</style>